export default __webpack_public_path__ + "static/media/169.3b053d32.png";